import {DI} from '../types'
import {ContainerModule, ContainerModuleLoadOptions} from 'inversify'
import {PulseAnalytics} from '@/src/core/application/analytics/pulse-analytics'
import {PulseAnalyticService} from '@/src/infrastructure/services/pulse-analytic-service'
import {MindboxAnalytics} from '@/src/core/application/analytics/mindbox-analytics'
import {MindboxAnalyticService} from '@/src/infrastructure/services/mindbox-analytic-service'

const initializeModule = ({bind}: ContainerModuleLoadOptions) => {
  bind<PulseAnalytics>(DI.PulseAnalytics).toDynamicValue(() => {
    return new PulseAnalytics(new PulseAnalyticService())
  })
  bind<MindboxAnalytics>(DI.MindboxAnalytics).toDynamicValue(() => {
    return new MindboxAnalytics(new MindboxAnalyticService())
  })
}

export const AnalyticModule = new ContainerModule(initializeModule)
